import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { BehaviorSubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminSettingsService {

  private loginTypeSubject = new BehaviorSubject<string>('simple');
  loginType$ = this.loginTypeSubject.asObservable();

  constructor(private apiService: ApiService) { }

  updateLoginType(type: string) {
    this.loginTypeSubject.next(type);
  }

  getAdminSettings() {
    return this.apiService.get('admin-settings').pipe(
      tap((res: any) => {
        if (res.data && res.data[0]) {
          this.updateLoginType(res.data[0].login_type);
        }
      })
    );
  }

  createAdminSettings(data: any) {
    return this.apiService.post('admin-settings', data).pipe(
      tap((res: any) => {
        if (res.success && data.login_type) {
          this.updateLoginType(data.login_type);
        }
      })
    );
  }
}
